import { Component, Inject, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { ActionHistoryInfo } from '../../models/manage-equipment.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-inspection-note',
  templateUrl: './inspection-note.component.html',
  styleUrls: ['./inspection-note.component.scss']
})
export class InspectionNoteComponent implements OnInit {
  comment:string; 
  FamilyId:number;
  Interpcomment:string; 

  ActionComment:ActionHistoryInfo[];
  InspectionType:number=0;

  constructor(
    public dialogRef: MatDialogRef<InspectionNoteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _notification: NotificationsService,
   ) { }

  ngOnInit() {
    console.log("data__", this.data)
    this.comment=this.data.comment;
    this.FamilyId = this.data.FamilyId;
    this.Interpcomment = this.data.Interpcomment;
    this.ActionComment = this.data.ActionComment;
    this.InspectionType = this.data.InspectionType;
  
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }


}
